import React from 'react';
interface PanelCardProps {
  title: string;
  meta?: string;
  children: React.ReactNode;
  className?: string;
  titleId?: string;
}
/**
 * Shared surface language: a white panel with a black title bar.
 * Used for the offer, the closing CTA and the checkout so the commercial
 * moments of the site all read as the same object.
 */
export function PanelCard({
  title,
  meta,
  children,
  className = '',
  titleId
}: PanelCardProps) {
  return <div className={`overflow-hidden border-2 border-white bg-white ${className}`} data-id="element-159" data-mp="3hucdeq3lt316">
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 bg-black px-6 py-5 sm:px-9 sm:py-6" data-id="element-160" data-mp="3ms4117x7u2zk">
        <h2 id={titleId} className="max-w-2xl text-2xl font-medium tracking-[-0.03em] text-white sm:text-3xl" data-id="element-161" data-mp="3rqnnd9fq1gsg">
          {title}
        </h2>
        {meta && <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-white/60" data-id="element-162" data-mp="1xgk4x2fd778k">
            {meta}
          </p>}
      </div>
      {children}
    </div>;
}